import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardEcommerce from "../pages/DashboardEcommerce";
import TableSeatOptimization from "../pages/TableSeatOptimization";
import MenuEngineering from "../pages/MenuEngineering";
import ServerPerformance from "../pages/ServerPerformance";
import MenuDesign from "../pages/MenuDesign";
import ServerUpselling from "../pages/ServerPerformance/ServerUpselling";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import PasswordReset from "../pages/Authentication/PasswordReset";
import PasswordUpdate from "../pages/Authentication/PasswordUpdate";

// User Profile
import UserProfile from "../pages/Authentication/UserProfile";
import FlashDashboard from "../pages/DashboardEcommerce/FlashDashboard";
import NotificationConfig from "../pages/Authentication/NotificationConfig";
import ForecastBudget from "../pages/Authentication/ForecastBudget";
import Support from "../pages/Authentication/Support";
import Flash from "../pages/Flash";
import Discount from "../pages/Discount";
import Reports from "../pages/Reports";
import MyDashboard from "../pages/Reports/MyDashboard";
import SSOLogin from "../pages/Authentication/SSOLogin";
import ManageGroups from "../pages/Authentication/ManageGroups";
import RestaurantAnalytics from "../pages/DashboardAnalytics";
import CaptureRatio from "../pages/CaptureRatio";
import DiscountNew from "../pages/DiscountNew";
import ForcastNew from "../pages/ForcastNew";
import CheckListing from "../pages/CheckListing";
import CookiePolicy from "../pages/Authentication/CookiePolicy";
import TeamBenchmark from "../pages/TeamBenchmark";
import RoiCalculation from "../pages/RoiCalculation/RoiCalculation";
import Coaching from "../pages/Coaching";
import FlashCards from "../pages/Coaching/FlashCards";
import MenuManagement from "../pages/Coaching/MenuManagement";
import ServerManagement from "../pages/Coaching/ServerManagement";
import CreateFlashCard from "../pages/Coaching/CreateFlashCard";

const authProtectedRoutes = [
  {
    path: "/playground",
    component: DashboardEcommerce,
    right_key: "kpi_dashboard",
  },
  { path: "/index", component: DashboardEcommerce, right_key: "kpi_dashboard" },
  { path: "/flash", component: Flash, right_key: "kpi_dashboard" },
  { path: "/forecast", component: FlashDashboard, right_key: "forecast" },
  {
    path: "/table-seat-optimization",
    component: TableSeatOptimization,
    right_key: "table_seat_optimization",
  },
  {
    path: "/menu-optimization",
    component: MenuEngineering,
    right_key: "menu_optimization",
  },
  { path: "/menu-design", component: MenuDesign, right_key: "menu_design" },
  {
    path: "/server-performance",
    component: ServerPerformance,
    right_key: "server_performance",
  },
  { path: "/upselling", component: ServerUpselling, right_key: "upselling" },
  { path: "/profile", component: UserProfile, right_key: "profile" },
  {
    path: "/notification-config",
    component: NotificationConfig,
    right_key: "notification-config",
  },
  {
    path: "/forecast-and-budget",
    component: ForecastBudget,
    right_key: "forecast-and-budget",
  },
  { path: "/support", component: Support, right_key: "support" },
  { path: "/discount-list", component: Discount, right_key: "kpi_dashboard" },
  { path: "/reports", component: Reports, right_key: "kpi_dashboard" },
  {
    path: "/my-dashboard/:id",
    component: MyDashboard,
    right_key: "kpi_dashboard",
  },
  {
    path: "/manage-groups",
    component: ManageGroups,
    right_key: "manage-groups",
  },
  {
    path: "/restaurant-analytics",
    component: RestaurantAnalytics,
    right_key: "restaurant-analytics",
  },
  {
    path: "/capture-ratio",
    component: CaptureRatio,
    right_key: "capture_ratio",
  },
  { path: "/discount-dashboard", component: DiscountNew, right_key: 'discount_dashboard' },
  { path: "/check-listing", component: CheckListing, right_key: 'discount_dashboard' },
  { path: "/team-benchmark", component: TeamBenchmark, right_key: 'discount_dashboard' },
  { path: "/roi-calculation", component: RoiCalculation, right_key: 'discount_dashboard' },  
  { path: "/server-performance-coaching", component: Coaching, right_key: 'discount_dashboard' },
  { path: "/flash-cards", component: FlashCards, right_key: 'discount_dashboard' },
  { path: "/menu-management", component: MenuManagement, right_key: 'discount_dashboard' },
  { path: "/server-management", component: ServerManagement, right_key: 'discount_dashboard' },
  { path: "/create-flash-card", component: CreateFlashCard, right_key: 'discount_dashboard' },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/playground" />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/register", component: Register },
  { path: "/password-reset/:verifycode", component: PasswordReset },
  { path: "/password-update/:verifycode", component: PasswordUpdate },
  { path: "/sso-login", component: SSOLogin },
  { path: "/cookie-policy", component: CookiePolicy },
];

export { authProtectedRoutes, publicRoutes };
